import React from 'react';

import { PAGE_TITLE } from '../../constants';
import Component from '../../components/client';
import Container from '../../containers/client';
import Root from '../../components/root';

export default function PageClient() {
  return (
    <Root title={PAGE_TITLE.CLIENT}>
      <Container>
        <Component />
      </Container>
    </Root>
  );
};
